import { createGaEventRecord } from "@/features/ga/utils";

export const gaEventRecords = {
  ...createGaEventRecord({
    billingMaacTopUpClick: {
      name: "billing_maac_top_up_click",
      description: "User clicks on the MAAC top-up button on the billing page",
    },
    billingCaacTopUpClick: {
      name: "billing_caac_top_up_click",
      description: "User clicks on the CAAC top-up button on the billing page",
    },
    gadsContactUsClick: {
      name: "gads_contact_us_click",
      description:
        "User clicks on the Contact Us button on Google Ads card when EC module is disabled",
    },
    productFeedContactUsClick: {
      name: "pf_contact_us_click",
      description:
        "User clicks on the Contact Us button on Product Feed card when module is disabled",
    },
    customFieldContactUsClick: {
      name: "cf_contact_us_click",
      description:
        "User clicks on the Contact Us button on Custom Field card when limit is not available",
    },
    openApiContactUsClick: {
      name: "openapi_contact_us_click",
      description:
        "User clicks on the Contact Us button on OpenAPI card when OpenAPI v2 is not enabled for the organization",
    },
    mcpContactUsClick: {
      name: "mcp_contact_us_click",
      description:
        "User clicks on the Contact Us button on MCP card when MCP is not enabled for the organization",
    },
  }),
};
